// extracted by mini-css-extract-plugin
export var discard = "_46-3";
export var muiTooltipTooltip = "_46-5";
export var notificationBar = "_46-2";
export var saveButtonHoverSlotWrapper = "_46-4";
export var show = "_46-1";
export var spacer = "_46-0";